(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(root = document) {
    root.querySelectorAll('[data-home-campaign]').forEach(carousel => {
      if (carousel.dataset.ready) return;
      carousel.dataset.ready = 'true';
      const slides = [...carousel.querySelectorAll('[data-home-slide]')];
      const dots = [...carousel.querySelectorAll('[data-home-dot]')];
      const pause = carousel.querySelector('[data-home-autoplay]');
      let selected = 0, playing = !reduced.matches, timer, startX;
      const show = index => {
        selected = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== selected; });
        dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === selected)));
      };
      const schedule = () => {
        clearInterval(timer);
        if (playing && slides.length > 1 && !document.hidden) timer = setInterval(() => show(selected + 1), 7000);
        pause.textContent = playing ? 'Pause' : 'Play';
        pause.setAttribute('aria-label', playing ? 'Pause campaigns' : 'Play campaigns');
      };
      dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); schedule(); }));
      pause.addEventListener('click', () => { playing = !playing; schedule(); });
      carousel.addEventListener('focusin', () => clearInterval(timer));
      carousel.addEventListener('focusout', schedule);
      carousel.addEventListener('mouseenter', () => clearInterval(timer));
      carousel.addEventListener('mouseleave', schedule);
      carousel.addEventListener('pointerdown', event => { startX = event.clientX; });
      carousel.addEventListener('pointerup', event => {
        if (startX !== undefined && Math.abs(event.clientX - startX) > 50) { show(selected + (event.clientX < startX ? 1 : -1)); schedule(); }
        startX = undefined;
      });
      carousel.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); show(selected + (event.key === 'ArrowRight' ? 1 : -1)); dots[selected].focus(); }
      });
      document.addEventListener('visibilitychange', schedule);
      schedule();
    });
    root.querySelectorAll('[data-home-products]').forEach(group => {
      if (group.dataset.ready) return;
      group.dataset.ready = 'true';
      const tabs = [...group.querySelectorAll('[data-home-tab]')];
      const panels = [...group.querySelectorAll('[data-home-panel]')];
      const dropdown = group.querySelector('[data-home-dropdown]');
      const toggle = group.querySelector('[data-home-dropdown-toggle]');
      function select(index) {
        tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
        panels.forEach((panel, i) => { panel.hidden = i !== index; });
        const titleEl = group.querySelector('[data-home-collection-title]');
        if (titleEl) titleEl.textContent = tabs[index].textContent.trim();
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        if (dropdown) dropdown.classList.remove('is-open');
      }
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(i));
        tab.addEventListener('keydown', event => {
          let index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') index = (i + 1) % tabs.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') index = (i + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') index = 0;
          if (event.key === 'End') index = tabs.length - 1;
          if (index !== undefined) { event.preventDefault(); select(index); tabs[index].focus(); }
        });
      });
      if (toggle && dropdown) {
        toggle.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          const open = dropdown.classList.contains('is-open');
          toggle.setAttribute('aria-expanded', String(!open));
          dropdown.classList.toggle('is-open', !open);
        });
        document.addEventListener('click', event => {
          if (!dropdown.contains(event.target) && !toggle.contains(event.target)) {
            toggle.setAttribute('aria-expanded', 'false');
            dropdown.classList.remove('is-open');
          }
        });
        document.addEventListener('keydown', event => {
          if (event.key === 'Escape' && dropdown.classList.contains('is-open')) {
            toggle.setAttribute('aria-expanded', 'false');
            dropdown.classList.remove('is-open');
            toggle.focus();
          }
        });
      }
    });
    root.querySelectorAll('[data-home-scroll]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      const rail = document.getElementById(button.getAttribute('aria-controls'));
      if (!rail) return;
      button.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        if (button.disabled) return;
        const card = rail.querySelector('.home-product-card');
        const scrollAmount = card ? (card.offsetWidth + 24) * 2 : rail.clientWidth * 0.75;
        rail.scrollBy({ left: scrollAmount * Number(button.dataset.homeScroll), behavior: reduced.matches ? 'instant' : 'smooth' });
      });
    });
    root.querySelectorAll('.home-product-rail').forEach(rail => {
      if (rail.dataset.arrowsReady) return;
      rail.dataset.arrowsReady = 'true';
      const panel = rail.closest('[data-home-panel]');
      if (!panel) return;
      const prevBtn = panel.querySelector('[data-home-scroll="-1"]');
      const nextBtn = panel.querySelector('[data-home-scroll="1"]');
      const updateArrows = () => {
        const atStart = rail.scrollLeft <= 5;
        const atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 5;
        if (prevBtn) {
          prevBtn.disabled = atStart;
          prevBtn.setAttribute('aria-disabled', String(atStart));
          prevBtn.tabIndex = atStart ? -1 : 0;
        }
        if (nextBtn) {
          nextBtn.disabled = atEnd;
          nextBtn.setAttribute('aria-disabled', String(atEnd));
          nextBtn.tabIndex = atEnd ? -1 : 0;
        }
      };
      rail.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      const observer = new ResizeObserver(updateArrows);
      observer.observe(rail);
      setTimeout(updateArrows, 100);
    });
    root.querySelectorAll('[data-quick-add-form]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      form.addEventListener('submit', async event => {
        event.preventDefault();
        const btn = form.querySelector('.home-product-card__quick-add');
        if (!btn || btn.classList.contains('is-loading')) return;
        btn.classList.add('is-loading');
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            body: new FormData(form),
            headers: { 'Accept': 'application/json' }
          });
          if (!res.ok) throw new Error('Add to cart failed');
          btn.classList.remove('is-loading');
          btn.classList.add('is-success');
          setTimeout(() => btn.classList.remove('is-success'), 1500);

          const cartRes = await fetch('/cart.js');
          if (cartRes.ok) {
            const cart = await cartRes.json();
            document.querySelectorAll('.shell-cart span, [data-cart-count], .header-cart__count').forEach(el => {
              el.textContent = cart.item_count;
            });
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
            if (window.CartDrawer) {
              window.CartDrawer.openAndRefresh();
            } else {
              document.dispatchEvent(new CustomEvent('cart:refresh-and-open'));
            }
          }
        } catch (err) {
          console.error('Quick add failed:', err);
          btn.classList.remove('is-loading');
        }
      });
    });
    root.querySelectorAll('[data-home-video]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      const videos = [...button.parentElement.querySelectorAll('video')];
      let userPaused = false;
      if (reduced.matches) {
        userPaused = true;
        videos.forEach(video => video.pause());
      }
      const update = () => {
        const video = videos.find(v => v.offsetWidth > 0) || videos[0];
        const paused = userPaused || (!reduced.matches && video && video.hasAttribute('autoplay') ? video.paused && video.readyState > 2 : !video || video.paused);
        const pauseIcon = button.querySelector('.home-video-icon--pause');
        const playIcon = button.querySelector('.home-video-icon--play');
        if (pauseIcon && playIcon) {
          pauseIcon.style.display = paused ? 'none' : 'block';
          playIcon.style.display = paused ? 'block' : 'none';
        } else {
          button.textContent = paused ? 'Play' : 'Pause';
        }
        button.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
      };
      videos.forEach(video => {
        video.addEventListener('play', () => { userPaused = false; update(); });
        video.addEventListener('playing', () => { userPaused = false; update(); });
        video.addEventListener('pause', () => { update(); });
      });
      button.addEventListener('click', () => {
        const video = videos.find(v => v.offsetWidth > 0) || videos[0];
        if (!video) return;
        if (video.paused) {
          userPaused = false;
          video.play().catch(update);
        } else {
          userPaused = true;
          video.pause();
        }
        update();
      });
      update();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
